import type { CatalogSortField, CatalogSortDirection } from './SixCatalogDTOs';

export type SortKey = 'lastActivity' | 'name' | 'members' | 'files';

export type ViewMode = 'grid' | 'list';

export interface SortOption {
  key: SortKey;
  label: string;
}

/** Maps FE sort option keys to BE query parameters */
export const SORT_KEY_TO_PARAMS: Record<SortKey, { sortField: CatalogSortField; sortDirection: CatalogSortDirection }> = {
  lastActivity: { sortField: 'lastActivity', sortDirection: 'desc' },
  name: { sortField: 'name', sortDirection: 'asc' },
  members: { sortField: 'members', sortDirection: 'asc' },
  files: { sortField: 'files', sortDirection: 'asc' },
};
